import React, { useState, useContext } from 'react'

import { bool, shape } from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import API from 'utils/API'
// import csrfToken from 'utils/csrfToken'
// import AccessToken from 'utils/AccessToken'

import { Alert } from 'components/qstrap'
import Select from 'react-select'

import MoreInfoSVG from 'components/atoms/SVGIcons/MoreInfo'
import Typography from 'components/atoms/Typography'
import Paper from 'components/atoms/Paper'
import FormGroup from 'components/molecules/FormGroup'
// import InputField from 'components/atoms/InputField'

// import SubjectField from '../SubjectField'
import { PaperplaneFormContext } from '../PaperplaneFormContext'

const AlertGroupOT = (
  <Alert color="info">
    <div className="alert-content">
      <div className="alert-icon"><MoreInfoSVG fill="#766ddd" /></div>
      <Typography variant="caption" component="div" className="alert-message">
        <strong>IPC:</strong> Untuk dapat memilih kelompok jurusan ini, kamu diwajibkan untuk menyelesaikan Tryout TPS, Saintek dan Soshum<br/>
        <strong>Saintek:</strong> Untuk dapat memilih kelompok jurusan ini, kamu diwajibkan untuk menyelesaikan Tryout TPS dan Saintek<br/>
        <strong>Soshum:</strong> Untuk dapat memilih kelompok jurusan ini, kamu diwajibkan untuk menyelesaikan Tryout TPS dan Soshum<br/><br/>
        Selesaikan Online Tryout di <a href="https://learn.quipper.com" target="_blank" rel="noopener">learn.quipper.com</a>
      </Typography>
    </div>
    <style jsx>
      {`
        .alert {
          padding: 16px;
          margin-bottom: 16px;
          &-content {
            display: flex;
            flex-direction: column;
          }
          &-message {
            a {
              text-decoration: none;
            }
          }
          @media screen and (min-width: 768px) {
            &-content {
              flex-direction: row;
            }
            &-message {
              font-size: 14px !important;
            }
            &-icon {
              margin-right: 8px;
            }
          }
        }
      `}
    </style>
  </Alert>
)

const SchoolsSelectionForm = ({ classname, has_ot_score: hasOTScore }) => {
  const { state, dispatch } = useContext(PaperplaneFormContext)
  const [prog1, setProg1] = useState([])
  const [prog2, setProg2] = useState([])
  const [schools, setSchools] = useState([])
  const incompleteOT = !(hasOTScore.tps && hasOTScore.saintek && hasOTScore.soshum)

  const campusOptions = async (group) => {
    const campusOptsPath = `${API.endPoints().paperplane.campus_opts}`
    API.get(campusOptsPath, {
      category: group,
    }).then((response) => {
      setSchools(response.data.map(campusName => ({ label: campusName, value: campusName })))
    })
  }

  const studyProgramOptions1 = async (campusName) => {
    const otherGroup = state.programStudies[1] && state.programStudies[1].group
    const studyProgramOptsPath = `${API.endPoints().paperplane.study_prog_opts}`
    const response = await API.get(studyProgramOptsPath, {
      category: state.group,
      campus_name: campusName,
      other_group: (state.group === 'mix') ? otherGroup : undefined,
    })
    setProg1(response.data.map(studyProgram => ({
      label: studyProgram.name,
      value: studyProgram.code,
      group: studyProgram.category,
      isDisabled: (state.programStudies[1] && state.programStudies[1].id === studyProgram.code),
    })))
  }

  const studyProgramOptions2 = async (campusName) => {
    const otherGroup = state.programStudies[0] && state.programStudies[0].group
    const studyProgramOptsPath = `${API.endPoints().paperplane.study_prog_opts}`
    const response = await API.get(studyProgramOptsPath, {
      category: state.group,
      campus_name: campusName,
      other_group: (state.group === 'mix') ? otherGroup : undefined,
    })
    setProg2(response.data.map(studyProgram => ({
      label: studyProgram.name,
      value: studyProgram.code,
      group: studyProgram.category,
      isDisabled: (state.programStudies[0] && state.programStudies[0].id === studyProgram.code),
    })))
  }

  const handleGroupChange = (e) => {
    dispatch({
      type: 'SET_GROUP',
      payload: e.target.value,
    })

    dispatch({
      type: 'SET_SELECTED_CAMPUS1',
      payload: '',
    })

    dispatch({
      type: 'SET_SELECTED_CAMPUS2',
      payload: '',
    })

    dispatch({
      type: 'RESET_SCHOOLS_PROGRAM_STUDIES',
    })

    campusOptions(e.target.value)
  }

  return (
    <Paper shadowed>
      <div className={`${classname}__form`}>
        <Typography
          component="h1"
          variant="title-sm"
          style={{
          color: '#1A344F',
          fontSize: '28px',
        }}
        >
          Pilih Universitas dan Jurusan
        </Typography>
        <Typography component="p" variant="body">
          Masukkan dua pilihan universitas dan jurusan yang kamu tuju. Info ini akan digunakan untuk mengecek peluang lolos dengan nilai tryoutmu.
        </Typography>

        <div className="fields-group">
          <FormGroup
            id="test-group"
            labelText="Pilih Kelompok Ujian"
            alert={AlertGroupOT}
            showAlert={incompleteOT}
            required
          >
            <div className="radio-item">
              <input
                type="radio"
                value="mix"
                disabled={incompleteOT}
                checked={(state.group) === 'mix'}
                onChange={handleGroupChange}
              />
              <span>Campuran (IPC)</span>
            </div>
            <div className="radio-item">
              <input
                type="radio"
                value="saintek"
                disabled={!(hasOTScore.tps && hasOTScore.saintek)}
                checked={(state.group) === 'saintek'}
                onChange={handleGroupChange}
              />
              <span>Saintek</span>
            </div>
            <div className="radio-item">
              <input
                type="radio"
                value="soshum"
                disabled={!(hasOTScore.tps && hasOTScore.soshum)}
                checked={(state.group) === 'soshum'}
                onChange={handleGroupChange}
              />
              <span>Soshum</span>
            </div>
          </FormGroup>
        </div>

        <div className="fields-group">
          <Typography
            component="h5"
            variant="body"
            className="bold"
            style={{
            color: '#1A344F',
            fontSize: '16px',
          }}
          >
            Pilihan 1
          </Typography>
          <FormGroup
            id="selectedCampus1"
            labelText="Universitas"
            required
          >
            <Select
              components={{
                IndicatorSeparator: () => null,
              }}
              options={schools}
              defaultOptions={[{ label: 'Sedang memuat data', value: '' }]}
              isClearable
              name="selectedCampus1"
              placeholder="Pilih Universitas Kamu"
              onChange={
                (selected) => {
                  if (selected) {
                    dispatch({
                      type: 'SET_SELECTED_CAMPUS1',
                      payload: selected.value,
                    })
                    setProg1([{ label: 'Sedang memuat data', value: '' }])
                    studyProgramOptions1(selected.value)
                  } else {
                    dispatch({
                      type: 'SET_SELECTED_CAMPUS1',
                      payload: '',
                    })
                  }
                }
              }
              value={state.selectedCampus1 ?
                ({ label: state.selectedCampus1, value: state.selectedCampus1 }) :
                null
              }
              isSearchable
            />
          </FormGroup>
          <FormGroup
            id="selectedStudyProgram1"
            labelText="Jurusan"
            required
          >
            <Select
              components={{
                IndicatorSeparator: () => null,
              }}
              isClearable
              options={prog1}
              name="selectedStudyProgram1"
              isDisabled={!state.selectedCampus1}
              placeholder="Pilih Jurusan Kamu"
              onChange={
                (selected) => {
                  let programStudy

                  if (selected) {
                    programStudy = {
                      id: selected.value,
                      name: selected.label,
                      group: selected.group,
                    }
                  } else {
                    programStudy = ''
                  }

                  dispatch({
                    type: 'ADD_SELECTED_PROGRAM_STUDY',
                    payload: {
                      programStudy,
                      idx: 0,
                    },
                  })
                }
              }
              value={state.programStudies[0] ?
                ({ value: state.programStudies[0].id, label: state.programStudies[0].name }) :
                null
              }
              isSearchable
            />
          </FormGroup>
        </div>
        <div className="fields-group">
          <Typography
            component="h5"
            variant="body"
            className="bold"
            style={{
            color: '#1A344F',
            fontSize: '16px',
          }}
          >
            Pilihan 2
          </Typography>
          <FormGroup
            id="selectedCampus2"
            labelText="Universitas"
            required
          >
            <Select
              components={{
                IndicatorSeparator: () => null,
              }}
              options={schools}
              defaultOptions={[{ label: 'Sedang memuat data', value: '' }]}
              name="selectedCampus2"
              isClearable
              isDisabled={state.programStudies.length < 1}
              placeholder="Pilih Universitas Kamu"
              onChange={
                (selected) => {
                  if (selected) {
                    dispatch({
                      type: 'SET_SELECTED_CAMPUS2',
                      payload: selected.value,
                    })
                    setProg2([{ label: 'Sedang memuat data', value: '' }])
                    studyProgramOptions2(selected.value)
                  } else {
                    dispatch({
                      type: 'SET_SELECTED_CAMPUS2',
                      payload: '',
                    })
                  }
                }
              }
              value={state.selectedCampus2 ?
                ({ label: state.selectedCampus2, value: state.selectedCampus2 }) :
                null
              }
              isSearchable
            />
          </FormGroup>
          <FormGroup
            id="selectedStudyProgram2"
            labelText="Jurusan"
            required
          >
            <Select
              components={{
                IndicatorSeparator: () => null,
              }}
              isClearable
              options={prog2}
              name="selectedStudyProgram2"
              isDisabled={!state.selectedCampus2}
              placeholder="Pilih Jurusan Kamu"
              onChange={
                (selected) => {
                  let programStudy

                  if (selected) {
                    programStudy = {
                      id: selected.value,
                      name: selected.label,
                      group: selected.group,
                    }
                  } else {
                    programStudy = ''
                  }

                  dispatch({
                    type: 'ADD_SELECTED_PROGRAM_STUDY',
                    payload: {
                      programStudy,
                      idx: 1,
                    },
                  })
                }
              }
              value={state.programStudies[1] ?
                ({ value: state.programStudies[1].id, label: state.programStudies[1].name }) :
                null
              }
              isSearchable
            />
          </FormGroup>
        </div>
      </div>

      <style global jsx>
        {`
          .form-group__label {
            font-size: 14px !important;
            color: #1a344f;
          }
        `}
      </style>

      <style jsx>
        {`
          .validation-field {
            height: 0;
            opacity: 0;
            padding: 0;
            position: absolute;
            margin-top: -16px;
          }
        `}
      </style>
    </Paper>
  )
}

SchoolsSelectionForm.propTypes = {
  has_ot_score: shape({
    tps: bool,
    saintek: bool,
    soshum: bool,
  }),
}

SchoolsSelectionForm.defaultProps = {
  has_ot_score: {
    tps: false,
    saintek: false,
    soshum: false,
  },
}

export default branch({
  has_ot_score: ['serverProps', 'has_ot_score'],
}, SchoolsSelectionForm)
